import { actionTypes, getterTypes, mutationTypes, situacoes } from '@/core/constants'
import validacaoFormulario from '@/views/mixins/validacaoFormulario'
import logarOrgaoDoPedido from '@/views/mixins/logarOrgao'
import { mapGetters } from 'vuex'

export default {
	mixins: [validacaoFormulario, logarOrgaoDoPedido],
	computed: {
		...mapGetters({
			cabecalho: getterTypes.PEDIDO.GET_PEDIDO_PARA_CABECALHO,
			informacoesPedido: getterTypes.PEDIDO.GET_INFORMACOES,
			revisao: getterTypes.PEDIDO.GET_REVISAO_PEDIDO,
		}),
	},
	data() {
		return {
			tituloModalNumeroPedidoEditando: 'Editar Número do Pedido',
			exibirModalNumeroPedidoEditando: false,
			regrasNumeroPedido: [
				(value) => this.regraObrigatoriedade(value, 'O campo é obrigatório.'),
				(value) =>
					this.regraDeTamanhoMaximoString(
						value,
						30,
						'O campo do numero deve ser igual ou menor que 30 caracteres!',
					),
			],
			numeroDoPedidoIsManual: this.$store.state.parametrosSistema.numeroDoPedidoIsManual,
			situacaoPedido: null,
			situacoesValidas: [situacoes.PEDIDO.RASCUNHO.value, situacoes.PEDIDO.EM_ELABORACAO.value],
			idPedido: this.$route.params.id,
			nomeCampo: 'Número do Pedido',
			placeholderCampo: 'Informe o número do pedido aqui',
		}
	},
	methods: {
		podeExibirAcaoEditar() {
			return this.numeroDoPedidoIsManual && this.estaEmElaboracao(this.informacoesPedido)
		},
		abrirOufecharModalNumeroPedidoEditando() {
			this.exibirModalNumeroPedidoEditando = !this.exibirModalNumeroPedidoEditando
		},
		async salvarNumeroPedido() {
			await this.$store.dispatch(actionTypes.PEDIDO.SALVAR_NUMERO_PEDIDO, {
				idPedido: this.$route.params.id,
				numeroPedido: this.$store.state.campoEditarNumero.numero,
			})
			this.$store.commit(mutationTypes.PEDIDO.SET_NUMERO, this.$store.state.campoEditarNumero.numero)
			this.montarInformacoesCabecalho()
		},
		async carregarCabecalho() {
			await Promise.all([this.buscarInformacoesDoPedido(), this.buscarRevisaoDisponivel()])
			this.montarInformacoesCabecalho()
		},
		montarInformacoesCabecalho() {
			this.$store.commit(mutationTypes.COMUM.SET_INFO_CABECALHO, this.cabecalho)
		},
		async buscarInformacoesDoPedido() {
			var data = await this.$store.dispatch(actionTypes.PEDIDO.BUSCAR_INFORMACOES, this.$route.params.id)

			if (data.usuarioGestorAta) {
				await this.atualizarSessaoComOOrgao(data.unidadeOrganizacional.id)
			} else {
				await this.atualizarSessaoComOOrgao(data.idOrgao)
			}

			this.idAta = data.ataRegistroPreco.id

			this.$store.state.pedido.numeroCasasDecimaisQtde = data.numeroCasasDecimaisQtde
			this.$store.state.pedido.numeroCasasDecimaisValores = data.numeroCasasDecimaisValores
		},
		async buscarRevisaoDisponivel() {
			await this.executarSemLoading(() =>
				this.$store.dispatch(actionTypes.PEDIDO.REVISOES.BUSCAR_DISPONIVEL, this.idPedido),
			)
		},
	},
}
